import React, { useEffect, useRef, useState } from "react";
import SummaryCard from "../../components/SummaryCard/SummaryCard";
import "../DashBoard/DashBoard.css";
import Button from "../../components/Button/Button";
//import { Globals } from "../../global/Globals";
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import Pagination from "../../components/Pagination/Pagination";
import {
  ccProposolsCount,
  fetch_proposals_Briefs,
  fetchFilterByCreatedBy,
  fetchFilterProposalStatus,
  shelveBriefUpdate,
  reactivateBriefUpdate,
  reAssingBriefSubmit,
} from "../../services/dashboardAPI";
import { fetchByfilter, fetchChannelbyClusters } from "../../services/GenericAPI";
import NoResultsComponent from "../../components/NoResults/NoResult";
import Loader from "../../components/Loader/Loader";
import Search from "../../components/SearchBar/Search";
import Table from "../../components/Table/Table";
import { useCluster } from "../../pages/ClusterContext/ClusterContext";
import Toast from "../../components/Toast/Toast";
import { useLocation, useNavigate } from "react-router-dom";
import PopUp from "../../components/PopUp/PopUp";
import { deleteBriefById } from "../../services/createBriefAPI";
import CryptoUtils from "../../util/cryptoUtils";
import { useRole } from "../../context/Rolecontext";
import { formatclusterandroleName } from "../../util/util";
import { useLanguage } from "../../context/Languagecontext";
import { Globals as OldGlobals } from "../../global/Globals";


let paginationPageChange = () => {};

const InternalDashboard = () => {
  const { Globals ,languages, setLanguages } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const createBriefToast = location?.state?.toastValue || '';
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("All");
  const [activeTimeTab, setActivetimetab] = useState("OneMonth");
  const [briefActiveTab, setBriefActiveTab] = useState("All");
  const [isHalfScreenPopupVisible, setIsHalfScreenPopupVisible] = useState(false);
  const [briefData, setBriefData] = useState(null);
  const [briefStatus, setbriefStatus] = useState(null);
  const [proposalCount, setProposalCount] = useState([]);
  const [enableClearAll, setEnableClearAll] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState(null);
  const [dataSorting, setDatasorting] = useState(1);
  const [Popup, setPopup]=useState({open:false, title:'', promptText:'', customClassName: '', normalActionText:'', textAreaTitle:'', textAreaStyle:'', toastMessage:'', body:''});
  const [toast, setToast] = useState({open:false, status:'', title:""});
  const [roleID, setroldId] = useState(CryptoUtils.getFromLocalStorage("roleId")?.toString());
  const [successToast, setSuccessToast] = useState({status:false,title:Globals.PROPOSAL_SUBMIT_SUCCESS});
  const [deletePopup, setDeletePopup]=useState({open:false});
  const { success,draft } = location.state || {};
  const [clusterId,setClusterId] =useState();
  const [clusterName, setClusterName] = useState();


  const isInitialRenderPage = useRef(true);
  const isInitialRenderSort = useRef(true);
  const isInitialRenderDropdown = useRef(true);
  const isInitialRenderSearch =useRef(true);
  const isInitialRenderLanguages = useRef(true);
  const { selectedClusters } = useCluster();
  const {selectedRole} =useRole();
   const [isClearAllTriggered, setIsClearAllTriggered] = useState(false);

  const [dropdownState, setDropdownState] = useState({
    activeDropdown: null,
    dropdowns: {
      CHANNEL: { options: [], selected: [], selectedText: [], isloading: false },
      CREATEDBY: { options: [], selected: [], selectedText: [], isloading: false },
      DATE: {
        selected: [],
        selectedMonthYear: [],
        selectedText: [],
        isDatePicker: true,
        isloading: false,
      },
      STATUS: { options: [], selected: [], selectedText: [], isloading: false },
    },
  });

  const dropdownRefs = useRef({});
  const prevSelectedState = useRef({});

  useEffect(()=>{
    if(createBriefToast && createBriefToast !== ""){
       renderToast("success",createBriefToast);
    }

  },[createBriefToast])
  useEffect(() => {
  
      if(draft){
        setSuccessToast({status:true,title:Globals.PROPOSAL_SAVE_SUCCESS});
      }else{  
        setSuccessToast({status:true,title:Globals.PROPOSAL_SUBMIT_SUCCESS});
      }
      setTimeout(() => {
        setSuccessToast({status:false,title:""});
      }, 4000);
   
  }, []);

  useEffect(() => {
    if (isInitialRenderDropdown.current) {
      isInitialRenderDropdown.current = false;
      prevSelectedState.current = Object.fromEntries(
        Object.entries(dropdownState.dropdowns).map(([key, value]) => [key, value.selected])
      );
      return;
    }

    let hasSelectedChanged = false;
  
    for (const key of Object.keys(dropdownState.dropdowns)) {
      const currentSelected = dropdownState.dropdowns[key]?.selected || [];
      const prevSelected = prevSelectedState.current[key] || [];
  
      if (JSON.stringify(currentSelected) !== JSON.stringify(prevSelected)) {
        hasSelectedChanged = true;
        break;
      }
    }

    if (!hasSelectedChanged && !isClearAllTriggered) return;
  
    const hasSelectedOptions = Object.values(dropdownState.dropdowns).some(
      (dropdown) => dropdown?.selected?.length > 0
    );

    setEnableClearAll(hasSelectedOptions || !!searchQuery);

    const data = {
      channel: dropdownState.dropdowns.CHANNEL.selected,
      createdBy: dropdownState.dropdowns.CREATEDBY.selected,
      [roleID === Globals.USER_ROLES.SNR_MGR ? "closingDate" : "closingDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      status: dropdownState.dropdowns.STATUS.selected,
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:clusterId,
    };
    paginationPageChange(1);
          fetchBriefdata(briefActiveTab, data, 1);

              // Update only selected values in ref
    prevSelectedState.current = Object.fromEntries(
      Object.entries(dropdownState.dropdowns).map(([key, value]) => [key, value.selected])
    );
  
    if (isClearAllTriggered) setIsClearAllTriggered(false);
  }, [dropdownState,isClearAllTriggered]);

  useEffect(() => {
    const hasSelectedOptions = Object.values(dropdownState.dropdowns).some(
      (dropdown) => dropdown.selected.length >= 0
    );
    if(clusterId){

    if (hasSelectedOptions) {
      const data = {
        channel: dropdownState.dropdowns.CHANNEL.selected,
        createdBy: dropdownState.dropdowns.CREATEDBY.selected,
        [roleID === Globals.USER_ROLES.SNR_MGR ? "closingDate" : "closingDate"]:
          dropdownState.dropdowns.DATE.selected.length > 0
            ? dropdownState.dropdowns.DATE.selected
            : "string",
        status: dropdownState.dropdowns.STATUS.selected,
        search: searchQuery ? searchQuery : "",
        filter: dataSorting,
        clusterId:clusterId,
      };
      paginationPageChange(1);
      fetchBriefdata(briefActiveTab, data, 1);
    }
  }
  }, [briefActiveTab]);

  useEffect(() => {
    if (isHalfScreenPopupVisible) {
      document.body.style.overflow = "hidden";
    } else {document.body.style.overflow = "auto";}
    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isHalfScreenPopupVisible]);

  useEffect(() => {

    if (isInitialRenderPage.current) {
      isInitialRenderPage.current = false;
      return; // Skip on first render
    }
          const data = {
      channel: dropdownState.dropdowns.CHANNEL.selected,
      createdBy: dropdownState.dropdowns.CREATEDBY.selected,
      closingDate:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      status: dropdownState.dropdowns.STATUS.selected,
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:clusterId,
    };

    fetchBriefdata(briefActiveTab, data, currentPage);
  
  }, [currentPage]);

  useEffect(() => {
    
    if (isInitialRenderSearch.current) {
      isInitialRenderSearch.current = false;
      return; // Skip on first render
    }
    const data = {
      channel: dropdownState.dropdowns.CHANNEL.selected,
      createdBy: dropdownState.dropdowns.CREATEDBY.selected,
      [roleID === Globals.USER_ROLES.SNR_MGR ? "closingDate" : "closingDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      status: dropdownState.dropdowns.STATUS.selected,
      search: searchQuery ? searchQuery : "",
      filter: "1",
      clusterId:clusterId,
    };
    paginationPageChange(1);
    fetchBriefdata(briefActiveTab, data, currentPage);
  }, [searchQuery]);

  useEffect(() => {
    if (isInitialRenderSort.current) {
      isInitialRenderSort.current = false;
      return; // Skip on first render
    }

    const data = {
      channel: dropdownState.dropdowns.CHANNEL.selected,
      createdBy: dropdownState.dropdowns.CREATEDBY.selected,
      [roleID === Globals.USER_ROLES.SNR_MGR ? "closingDate" : "closingDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      status: dropdownState.dropdowns.STATUS.selected,
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:clusterId ,
    };
    fetchBriefdata(briefActiveTab, data, currentPage);
  }, [dataSorting]);


  useEffect(() => {
    const newCluster = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"));
     setDropdownState((prev) => {
          const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
            acc[key] = { ...prev.dropdowns[key], options: [] };
            if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
              acc[key].selectedMonthYear = [];
            }
            return acc;
          }, {});
          return { ...prev, dropdowns: clearedDropdowns };
        });
      if (newCluster) {
        setClusterId(newCluster[0].clusterId);
        setClusterName(newCluster[0].clusterName);
      }
}, [selectedClusters]); 

useEffect(() => {
  if(clusterId){
    setroldId(selectedRole[0]?.roleId?.toString());
    roleSwitched();
  }
}, [selectedRole]); 

  useEffect(() => {
    if(clusterId && clusterName ){
      const data = {
        channel: dropdownState.dropdowns.CHANNEL.selected,
        createdBy: dropdownState.dropdowns.CREATEDBY.selected,
        [roleID === Globals.USER_ROLES.SNR_MGR ? "closingDate" : "closingDate"]:
          dropdownState.dropdowns.DATE.selected.length > 0
            ? dropdownState.dropdowns.DATE.selected
            : "string",
        status: dropdownState.dropdowns.STATUS.selected,
        search: searchQuery ? searchQuery : "",
        filter: dataSorting,
        clusterId:clusterId ,

      };
      paginationPageChange(1);
      fetchPorposolsCount(activeTab, activeTimeTab,clusterId);
      fetchBriefdata(briefActiveTab, data, 1);
  }
  }, [clusterId,clusterName]);

  const roleSwitched = () =>{
    const data = {
      channel: dropdownState.dropdowns.CHANNEL.selected,
      createdBy: dropdownState.dropdowns.CREATEDBY.selected,
      [roleID === Globals.USER_ROLES.SNR_MGR ? "closingDate" : "closingDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      status: dropdownState.dropdowns.STATUS.selected,
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:clusterId ,

    };
    paginationPageChange(1);
    fetchPorposolsCount(activeTab, activeTimeTab,clusterId);
    fetchBriefdata(briefActiveTab, data, 1);
}
  
  const refreshBriefData = async () => {
    const data = {
      channel: dropdownState.dropdowns.CHANNEL.selected,
      createdBy: dropdownState.dropdowns.CREATEDBY.selected,
      [roleID === "2" ? "closingDate" : "closingDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      status: dropdownState.dropdowns.STATUS.selected,
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId: clusterId,
    };
    await fetchBriefdata(briefActiveTab, data, currentPage);
  };

  useEffect(() => {
    const initialCluster = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"));
    if (initialCluster?.length > 0) {
      setClusterId(initialCluster[0]?.clusterId);
      setClusterName(initialCluster[0]?.clusterName);
    }
  }, []);


  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside all dropdowns
      const isClickInsideDropdown = Object.values(dropdownRefs.current).some((ref) =>
        ref?.contains(event.target)
      );
      if (!isClickInsideDropdown) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onPageChange = (pageNumber, setPage = () => {}) => {
    setCurrentPage(pageNumber);
    paginationPageChange = setPage;
  };

  const fetchBriefdata = async (proposalType, Filters, pageNumber) => {
    try {
      const response = await fetch_proposals_Briefs(proposalType, Filters, pageNumber);
      setBriefData(response.data.content);
      setbriefStatus(response.status);
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  };

  const fetchPorposolsCount = async (type, date ,cluster) => {
    try {
      const response = await ccProposolsCount(type, date, cluster);
      setProposalCount(response.data.content);
      //setbriefStatus(response.status);
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  };

  const openPopup = (data) =>{
    setPopup(data)
  }
  const closePopup = () =>{
    setPopup({open:false})
  }

  const closeDeltePopup = () =>{
    setDeletePopup({open:false})
  }
  
  const renderToast = (status,title) =>{
    setToast({open:true, status:status,title:title});
    setTimeout(() => {
      setToast({open:false, status:'',title:''});
    }, 4000);
  }

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    fetchPorposolsCount(tab, activeTimeTab,clusterId);
  };

  const handleTimeTabClick = (data) => {
    setActivetimetab(data);
    fetchPorposolsCount(activeTab, data, clusterId);
  };

  const handleBriefTabClick = (tab) => {
    setBriefActiveTab(tab);
  };

  const handletog = async (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));

    if (
      dropdownState.dropdowns[dropdownName]?.options &&
      dropdownState.dropdowns[dropdownName].options.length === 0
    ) {
      await fetchOptions(dropdownName);
    }
  };

  const shelveBriefStatus = (body,toastMessage) =>{
    shelveBriefUpdate(body)
          .then((response) => {
            if(response.data.status === "OK"){
             renderToast("success",toastMessage)
             handleShelveActivateRefresh()
            }else{ renderToast("error",Globals.TOAST_FAILURE);}
          })
          .catch((error) => {
            renderToast("error",Globals.TOAST_FAILURE)
          });
  }

  const reactivateBriefStatus = (body,toastMessage) =>{
    reactivateBriefUpdate(body)
          .then((response) => {
            if(response.data.status === "OK"){
             renderToast("success",toastMessage)
             handleShelveActivateRefresh()
            }else{ renderToast("error",Globals.TOAST_FAILURE);}
          })
          .catch((error) => {
            renderToast("error",Globals.TOAST_FAILURE)
          });
  }

  const reassignBrief = (body, toastMessage) => {
      const reAssignBriefRequestBody = {
        "proposalId": body?.proposalId,
        "proposalDetailId": 0,
        "status": 4,
        "comment": body?.comment,
        "clusterId": body?.clusterId,
        "channelId": body?.channelId,
      }
      reAssingBriefSubmit(reAssignBriefRequestBody)
        .then((response) => {
          if (response.data.status === "OK") {
            renderToast("success", toastMessage)
            handleRefresh()
          } else { 
            renderToast("error", Globals.TOAST_FAILURE);
           }
        }).catch((error) => {
                  renderToast("error",Globals.TOAST_FAILURE)
                });
  }

  
  const fetchOptions = async (dropdownName) => {
    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: true },
      },
    }));

    try {
      let response;
      let data;
      let filterData;
      if (dropdownName == OldGlobals.FETCH_CREATEDBY) {
        response = await fetchFilterByCreatedBy(roleID, clusterId);
        filterData = response.data.content;
      } else if (dropdownName == OldGlobals.FETCH_PROPOSALSTATUS) {
        response = await fetchFilterProposalStatus();
        filterData = response.data.content;
      } else if(dropdownName == OldGlobals.FETCH_CHANNEL) {
        response = await fetchChannelbyClusters(OldGlobals.FILTER_OPTIONS_NAME[dropdownName],clusterId);
        data = response.data.content;
        filterData = data;
      }
       else {
        response = await fetchByfilter(OldGlobals.FILTER_OPTIONS_NAME[dropdownName]);
        data = response.data.content;
        filterData = data[OldGlobals.FILTER_OPTIONS_NAME[dropdownName]];
      }

      // Simulate fetching options for each dropdown
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...prev.dropdowns[dropdownName],
            options: [...filterData],
            isLoading: false,
          },
        },
      }));
    } catch (error) {
      console.error("Error fetching options:", error);
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: false },
        },
      }));
    }
  };

  const handleSelectAll = (dropdownName, selectAll, options) => {
    setbriefStatus(null);
    const selectedDataString = options.map((option) => String(option.id));
    const selectedDataText = options.map((option) => String(option.name));

    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: {
          ...prev.dropdowns[dropdownName],
          selected: selectAll ? selectedDataString : [],
          selectedText: selectAll ? selectedDataText : [],
        },
      },
    }));
  };

  const deleteNewBrief = async (data) => {
    setDeletePopup({
      open: true,
      title: Globals.DELETE_NEW_BRIEF.POPUP.delete.TITLE,
      negativeActionText: Globals.DELETE_NEW_BRIEF.POPUP.delete.BUTTON_TEXT,
      promptText: Globals.DELETE_NEW_BRIEF.POPUP.delete.MESSAGE,
      negativeAction: true,
      negativeAction: async () => {
        try {
          await deleteBriefById(data.proposalId);
          closeDeltePopup();
          renderToast("success", Globals.CREATE_NEW_BRIEF.TOAST_BRIEF_DELETE_MSG)
          await refreshBriefData();
        } catch (error) {
          renderToast("error", Globals.TOAST_FAILURE);
        }
      },
    });
  };

  const handleSelect = (dropdownName, value) => {
    setbriefStatus(null);
    setDropdownState((prev) => {
      const dropdown = prev.dropdowns[dropdownName];
      if (!dropdown) return prev;

      const isSelected = dropdown.selected.includes(String(value.id));
      const inSelectedText = dropdown.selectedText.includes(String(value.name));

      const newSelected = isSelected
        ? dropdown.selected.filter((item) => item !== String(value.id)).map(String)
        : [...dropdown.selected.filter((item) => item !== String(value.id)), String(value.id)];

      const newSelectedText = inSelectedText
        ? dropdown.selectedText.filter((item) => item !== String(value.name)).map(String)
        : [
            ...dropdown.selectedText.filter((item) => item !== String(value.name)),
            String(value.name),
          ];

      return {
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...dropdown,
            selected: newSelected,
            selectedText: newSelectedText,
          },
        },
      };
    });
  };

  const handleClearAll = () => {
    if (enableClearAll) {
      setbriefStatus(null);
      setCurrentPage(1);
      setEnableClearAll(false);
      setSearchQuery(null);
      setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [] };
          if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
            acc[key].selectedMonthYear = [];
          }
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });
      setIsClearAllTriggered(true); 
    }
  };

  const handleDateChange = (dropdownName, date) => {
    setbriefStatus(null);
    if (date instanceof Date && !isNaN(date)) {
      const month = date.getMonth() + 1; // Months are 0-based
      const year = date.getFullYear();
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const MonthName = monthNames[month - 1];
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...prev.dropdowns[dropdownName],
            selected: month + "-" + year,
            selectedMonthYear: month + "," + year,
            selectedText: MonthName + "-" + year,
          },
        },
      }));
    }
  };

  const handleSorting = (sorting) => {
        setbriefStatus(null);
    setDatasorting(sorting);
  };

  const handleRefresh =() => {
    const data = {
      channel: dropdownState.dropdowns.CHANNEL.selected,
      createdBy: dropdownState.dropdowns.CREATEDBY.selected,
      [roleID === Globals.USER_ROLES.SNR_MGR ? "closingDate" : "closingDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      status: dropdownState.dropdowns.STATUS.selected,
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:clusterId,
    };
    paginationPageChange(1);
    fetchBriefdata(briefActiveTab, data, 1);
  }

  const handleShelveActivateRefresh =() => {
    const data = {
      channel: dropdownState.dropdowns.CHANNEL.selected,
      createdBy: dropdownState.dropdowns.CREATEDBY.selected,
      [roleID === Globals.USER_ROLES.SNR_MGR ? "closingDate" : "closingDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      status: dropdownState.dropdowns.STATUS.selected,
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:clusterId,
    };
    paginationPageChange(1);
    fetchBriefdata(briefActiveTab, data, 1);
  }

  const handleSearch = (term) => {
    setSearchQuery(term);
    const dropdownSelected = Object.values(dropdownState?.dropdowns || {}).some(
      (dropdown) => dropdown?.selected?.length > 0
    );
    setbriefStatus(null);
    setEnableClearAll(term !== "" || dropdownSelected);
  };

  const dropdownselected = Object.values(dropdownState?.dropdowns).some(
    (dropdown) => dropdown?.selected && dropdown?.selected.length > 0
  );

  //language change logic
   useEffect(() => {
      if (isInitialRenderLanguages.current) {
      isInitialRenderLanguages.current = false;
      return; // Skip on first render
    }
    setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [], options: [] };
          if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
            acc[key].selectedMonthYear = [];
          }
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });
    const data = {
        channel: dropdownState.dropdowns.CHANNEL.selected,
        createdBy: dropdownState.dropdowns.CREATEDBY.selected,
        [roleID === Globals.USER_ROLES.SNR_MGR ? "closingDate" : "closingDate"]:
          dropdownState.dropdowns.DATE.selected.length > 0
            ? dropdownState.dropdowns.DATE.selected
            : "string",
        status: dropdownState.dropdowns.STATUS.selected,
        search: searchQuery ? searchQuery : "",
        filter: dataSorting,
        clusterId:clusterId ,

      };
      paginationPageChange(1);
      fetchPorposolsCount(activeTab, activeTimeTab,clusterId);
      fetchBriefdata(briefActiveTab, data, 1);
   }, [languages]);


  return (
    <div className="dashboard">
      <div className="dashboard-top">
        <div className="dashboard-heading">{Globals.PRODUCER.DASHBOARD}</div>
       {roleID != Globals.USER_ROLES.SNR_MGR && roleID != Globals.USER_ROLES.HOP ? <Button action={() => {
                    navigate(Globals.NAVPATH.CREATE_NEW_BRIEF, { state: { activeHeader: "dashboard" } });
                  }} title={Globals.PRODUCER.NEWBRIEF} additionalStyle={"new-proposal"} id={"Create_New_Brief"} /> :""}
      </div>
      <div className="dashboard-overview">
        <div className="proposal-overview">
          <div className="proposals-heading">
            <div>{Globals.PRODUCER.ALLPROPOSALS}</div>
            {clusterName ? <div className="Internal-dashbaord-pipe"></div> : "" }
            <div className="Cluster-name">{clusterName ? Globals.UNSOLICITED_PROPOSAL_HALF.CLUSTER +": " + Globals.CLUSTERNAME[formatclusterandroleName(clusterName,"Cluster")] : ""} </div>
          </div>

          <div className="proposal-overview-tabs">
            <div className="active-inactive-tabs">
              <div
                className={`proposal-overview-tab ${activeTab === "All" ? "active" : ""}`}
                onClick={() => handleTabClick("All")}
              >
                {Globals.DASHBOARD.ALL}
              </div>
              <div
                className={`proposal-overview-tab ${activeTab === "Solicited" ? "active" : ""}`}
                onClick={() => handleTabClick("Solicited")}
              >
                {Globals.DASHBOARD.SOLICITED}
              </div>
              <div
                className={`proposal-overview-tab ${activeTab === "Unsolicited" ? "active" : ""}`}
                onClick={() => handleTabClick("Unsolicited")}
              >
                {Globals.DASHBOARD.UNSOLICITED}
              </div>
            </div>
            <div className="date-timetabs">
              <div
                className={`date-overview-tab ${activeTimeTab === "OneMonth" ? "active" : ""}`}
                onClick={() => handleTimeTabClick("OneMonth")}
              >
                {Globals.DASHBOARD.ONEMONTH}
              </div>
              <div
                className={`date-overview-tab ${activeTimeTab === "SixMonths" ? "active" : ""}`}
                onClick={() => handleTimeTabClick("SixMonths")}
              >
                {Globals.DASHBOARD.SIXMONTHS}
              </div>
              <div
                className={`date-overview-tab ${activeTimeTab === "OneYear" ? "active" : ""}`}
                onClick={() => handleTimeTabClick("OneYear")}
              >
                {Globals.DASHBOARD.ONEYEAR}
              </div>
              <div
                className={`date-overview-tab ${activeTimeTab === "All" ? "active" : ""}`}
                onClick={() => handleTimeTabClick("All")}
              >
                {Globals.DASHBOARD.GREATERTHANONEYEAR}
              </div>
            </div>
          </div>
          <div className="summary-cards">
            {proposalCount && proposalCount.length > 0
              ? proposalCount?.map((item) => (
                  <>
                    {Object.keys(item)
                      .slice(0)
                      .map((key) => (
                        <SummaryCard
                          key={`${item.id}-${key}`}
                          title={key}
                          count={item[key]}
                          submissionType
                        />
                      ))}
                  </>
                ))
              : briefStatus &&
                briefStatus.length > 0 && (
                  <div className="no-data">
                    <NoResultsComponent
                      data={{
                        message: Globals.NO_RESULTS_MESSAGE,
                        img: Globals.NO_RESULTS_IMG,
                        submessage: Globals.NO_RESULTS_DASHBOARD_MESSAGE,
                      }}
                    />
                  </div>
                )}
          </div>
        </div>
      </div>

      <div className="dashboard-brief">
        <div className="dashboard-breif_heading">{Globals.PRODUCER.SOLICITEDBRIEF}</div>
        <div className="dashboard-brief-tabs">
          <div
            className={`dashboard-brief-tab ${briefActiveTab === "All" ? "active" : ""}`}
            onClick={() => handleBriefTabClick("All")}
          >
            {Globals.DASHBOARD.ALL}
          </div>
          <div
            className={`dashboard-brief-tab ${briefActiveTab === "Open" ? "active" : ""}`}
            onClick={() => handleBriefTabClick("Open")}
          >
            {Globals.DASHBOARD.OPEN}
          </div>
          <div
            className={`dashboard-brief-tab ${briefActiveTab === "Invited" ? "active" : ""}`}
            onClick={() => handleBriefTabClick("Invited")}
          >
            {Globals.DASHBOARD.CLOSED}
          </div>
        </div>

      <div className={`filters filters-${languages}`}>
          <div className="results">{briefData?.pageCount} {Globals.PRODUCER.BRIEFS}</div>
          <div className="row_spearator"></div>
          <div className="filterHeading">{Globals.PRODUCER.FILTERBY}</div>

          <CheckboxDropDown
            isOpen={activeDropdown === "CHANNEL"}
            options={dropdownState.dropdowns.CHANNEL.options}
            onToggle={() => handletog("CHANNEL")}
            onSelectAll={(selectAll, options) => handleSelectAll("CHANNEL", selectAll, options)}
            onSelect={(value) => {
              handleSelect("CHANNEL", value);
            }}
            selectedValues={dropdownState.dropdowns.CHANNEL.selected}
            title={Globals.FILTER.CHANNEL}
            isDatePicker={false}
            isCreatedBy={false}
            dropdownRef={(el) => (dropdownRefs.current["Channel"] = el)}
            selectedItems={dropdownState.dropdowns.CHANNEL.selectedText}
          />

          <CheckboxDropDown
            isOpen={activeDropdown === "CREATEDBY"}
            options={dropdownState.dropdowns.CREATEDBY.options}
            onToggle={() => handletog("CREATEDBY")}
            onSelectAll={(selectAll, options) => handleSelectAll("CREATEDBY", selectAll, options)}
            onSelect={(value) => handleSelect("CREATEDBY", value)}
            title={Globals.FILTER.CREATEDBY}
            isDatePicker={false}
            isCreatedBy={true}
            selectedValues={dropdownState.dropdowns.CREATEDBY.selected}
            dropdownRef={(el) => (dropdownRefs.current["CreatedBy"] = el)}
            selectedItems={dropdownState.dropdowns.CREATEDBY.selectedText}
          />

          <CheckboxDropDown
            isOpen={activeDropdown === "DATE"}
            options={dropdownState.dropdowns.DATE.options}
            onToggle={() => handletog("DATE")}
            onSelectAll={(selectAll) => handleSelectAll("DATE", selectAll)}
            onSelect={(value) => handleSelect("DATE", value)}
            title={roleID === Globals.USER_ROLES.SNR_MGR ? Globals.FILTER.CLOSINGDATE : Globals.FILTER.CLOSINGDATE}
            isDatePicker={true}
            selectedValues={dropdownState.dropdowns.DATE.selected}
            selectedMonthYear={dropdownState.dropdowns.DATE.selectedMonthYear}
            selectedMonthYearText={dropdownState.dropdowns.DATE.selectedText}
            dropdownRef={(el) => (dropdownRefs.current["Date"] = el)}
            isClosingDate={true}
            onDateChange={(date) => handleDateChange("DATE", date)}
          />
          <CheckboxDropDown
            isOpen={activeDropdown === "STATUS"}
            options={dropdownState.dropdowns.STATUS.options}
            onToggle={() => handletog("STATUS")}
            onSelectAll={(selectAll, options) => handleSelectAll("STATUS", selectAll, options)}
            onSelect={(value) => handleSelect("STATUS", value)}
            selectedValues={dropdownState.dropdowns.STATUS.selected}
            title={Globals.FILTER.STATUS}
            isDatePicker={false}
            isCreatedBy={false}
            dropdownRef={(el) => (dropdownRefs.current["Status"] = el)}
            selectedItems={dropdownState.dropdowns.STATUS.selectedText}
          />

          <div
            className={enableClearAll ? "clear clearAllEnable" : "clear"}
            onClick={() => handleClearAll()}
          >
           {Globals.PRODUCER.CLEARALL}
          </div>

          <div className="search">
            <Search
              onSearch={handleSearch}
              searchedFor={searchQuery}
              placeholder={Globals.INTERNAL.SEARCHBRIEFNO}
            />
          </div>
        </div>
       
        <div className="Table_Data">
          {briefData?.briefs && briefData?.briefs.length > 0 ? (
            <Table key={roleID + '-table'} data={briefData.briefs} navigate={navigate} onSort={handleSorting} form={"internalDashboard"} onRefresh={handleRefresh} popupShow={openPopup} deleteNewBrief={deleteNewBrief} ClusterInfo={clusterId} sortKey ={dataSorting} />
          ) : briefStatus ? (
            <div className="no-data">
               <NoResultsComponent
                                data={{
                                  message:
                                    dropdownselected || (searchQuery && searchQuery.length > 0)
                                      ? Globals.NO_RESULTS_MESSAGE
                                      : Globals.NO_DATA_WITHOUTFILTER,
                                  img:
                                    dropdownselected || (searchQuery && searchQuery.length > 0)
                                      ? OldGlobals.NO_RESULTS_IMG
                                      : OldGlobals.NO_DATA_FOUND_IMG,
                                  submessage:
                                    dropdownselected || (searchQuery && searchQuery.length > 0)
                                      ? Globals.NO_RESULTS_SUBMESSAGE
                                      : "",
                                }}
                              />
            </div>
          ) : (
            <Loader height={50} width={50} component={"Dashboard"} />
          )}
        </div>

        <div className="pagination-container">
          {briefData && briefData?.briefs && briefData?.briefs?.length > 0 && (
            <Pagination
              totalPages={Math.ceil(
                briefData?.pageCount / Globals.MAX_COUNT.TABLE_DATA_COUNT
              )}
              currentPage={currentPage}
              onPageChange={onPageChange}
            />
          )}
        </div>
      </div>
      {Popup.open && <PopUp
          title={Popup.title}
          text={Popup.promptText}
          comments={Popup.isTextBox}
          limit="1024"
          customClassName={Popup.customClassName}
          negativeAction={Popup.negativeAction}
          negativeActionText={Popup.negativeActionText}
          onClose={closePopup}
          normalAction={Popup?.callback || ((data) => {
            Popup.title === Globals.HALF_PAGE_BRIEF_DETAILS.SHELVE_BRIEF ? shelveBriefStatus(data,Popup.toastMessage) :Popup.title === Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_BRIEF ?reassignBrief(data,Popup.toastMessage): reactivateBriefStatus(data,Popup.toastMessage)
          })}
          normalActionText={Popup.normalActionText}
          textAreaStyle={Popup.textAreaStyle}
          textAreaTitle={Popup.textAreaTitle}
          proposalBodyVal={Popup.body}
        />}
      {deletePopup.open && <PopUp
          title={deletePopup.title}
          text={deletePopup.promptText}
          comments={deletePopup.isTextBox}
          limit="1024"
          customClassName={deletePopup.customClassName}
          negativeAction={deletePopup.negativeAction}
          negativeActionText={deletePopup.negativeActionText}
          onClose={closeDeltePopup}
          normalAction={deletePopup.normalAction}
          normalActionText={deletePopup.normalActionText}
          textAreaStyle={deletePopup.textAreaStyle}
          textAreaTitle={deletePopup.textAreaTitle}
          proposalBodyVal={deletePopup.body}
        />}
      {toast.open && <Toast status= {toast.status} onClose={()=>{setToast({open:false, status:'',title:''})}} title={toast.title} />}

    </div>
  );
};

export default InternalDashboard;
